import { IGroup } from 'types/group.types'
import { IUserData } from 'types/user.types'
import { FixMeLater } from 'types'
import { IMessage, IMessageContent } from 'types/conversation.types'

import Input from './input/Input'
import Appear from './appear/appear'
import Archived from './archived'
import ReadOnly from './read-only/ReadOnly'
import Disabled from './disabled/Disabled'
import DisableOtr from './disable-otr/DisableOtr'
import JoinChannel from './join-channel/JoinChannel'


interface IMessageInputProps {
  groups?: IGroup[]
  isJoinChannel?: boolean
  isReadOnly?: boolean
  isArchived?: boolean
  isAppear?: boolean
  isDeactive?: boolean
  roomId?: string
  isOtr?: boolean
  disabledOtr?: boolean
  members?:string[]
  messageId?: string
  messageIdInThread?: string
  placeHolder: string
  users: IUserData
  initialInputData?: IMessageContent
  channel?: boolean
  isEditMessage?: boolean
  getInputProps?: FixMeLater
  onAppearChannel?: () => void
  onUploadAudio?: (audioData: Blob) => void
  onCancelEditMessage?: () => void
  onUnarchiveChannel?: () => void
  onJoinChannel?: () => void
  pendingHandler?: (message: IMessage) => void
  onScrollBottom?: () => void
  onUpdatePastedFileTargetId?: (id: string) => void
}

const MessageInput = ({
  groups,
  isJoinChannel,
  isReadOnly,
  isArchived,
  isAppear,
  isDeactive,
  roomId = '',
  isOtr,
  disabledOtr,
  members,
  messageId,
  messageIdInThread,
  placeHolder,
  users,
  channel,
  initialInputData,
  isEditMessage,
  getInputProps,
  onUploadAudio,
  onCancelEditMessage,
  onUnarchiveChannel,
  onJoinChannel,
  pendingHandler,
  onScrollBottom,
  onAppearChannel,
  onUpdatePastedFileTargetId,
}: IMessageInputProps) => {


  if (!isAppear && !messageIdInThread && !isEditMessage) {
    return <Appear onAppearChannel={onAppearChannel} isChannel={channel} isAppear={isAppear} />
  } else if (isArchived) {
    return (
      <Archived
        groups={groups || []}
        roomId={roomId}
        isThread={!!messageIdInThread}
        notSubscribed={isJoinChannel}
        onUnarchiveChannel={onUnarchiveChannel}
      />
    )
  } else if (isReadOnly) {
    return <ReadOnly />
  } else if (isDeactive && !isOtr) {
    return <Disabled />
  } else if (isJoinChannel) {
    return <JoinChannel onJoinChannel={onJoinChannel} />
  } else if (disabledOtr) {
    return <DisableOtr disabledOtr={disabledOtr} />
  } else if (isOtr && members?.length === 1) {
    return <DisableOtr disabledOtr={false} />
  } 

  return (
    <Input
      users={users}
      isOtr={isOtr}
      roomId={roomId}
      messageId={messageId}
      messageIdInThread={messageIdInThread}
      initialInputData={initialInputData}
      isEditMessage={isEditMessage}
      placeHolder={placeHolder}
      onUploadAudio={onUploadAudio}
      onCancelEditMessage={onCancelEditMessage}
      getInputProps={getInputProps}
      pendingHandler={pendingHandler}
      onScrollBottom={onScrollBottom}
      onUpdatePastedFileTargetId={
        onUpdatePastedFileTargetId || undefined
      }
    />
  )
}

export default MessageInput
